import { postRequest } from './api';

const reportingApi = {
  /**
   * Generar reporte PPTX con preview
   * @param {Object} reportConfig - Configuración del reporte
   * @returns {Promise<Object>} - { pptx_base64, preview_images, filename, total_slides }
   */
  async generatePPTReport(reportConfig) {
    const response = await postRequest('/api/reporting/generate-pptx', reportConfig);
    return response;
  },

  /**
   * Regenerar reporte PPTX con cambios editados
   * @param {number} brandId - ID de la marca
   * @param {Array} slidesData - Estructura de slides editada
   * @param {Object} config - Configuración original del reporte
   * @returns {Promise<Object>} - { pptx_base64, filename }
   */
  async regeneratePPTReport(brandId, slidesData, config) {
    const response = await postRequest('/api/reporting/regenerate-pptx', {
      brand_id: brandId,
      slides_data: slidesData,
      config: config
    });
    return response;
  },

  /**
   * Descargar archivo PPTX desde base64
   * @param {string} base64Data - Datos del archivo en base64
   * @param {string} filename - Nombre del archivo
   */
  downloadPPT(base64Data, filename) {
    try {
      // Convertir base64 a blob
      const byteCharacters = atob(base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], {
        type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation'
      });

      // Descargar archivo
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename || 'reporte-esporai.pptx';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error descargando PPTX:', error);
      throw new Error('Error al descargar el archivo');
    }
  }
};

export default reportingApi;
